import useDiscard from "../../useDiscard";
import useMap from "../../utils/useMap";
import { getTemplateId } from "./useTemplateIdentify";

const store = useMap()

const values = (props, name) => store.get(getTemplateId(props)).get(name);

const useMultipleValueSelection = (props, name) => {
    const templateId = getTemplateId(props);
    if (!store.has(templateId)) {
        store.set(templateId, useMap());
    }
    if (!store.get(templateId).get(name)) {
        store.get(templateId).set(name, new Set());
    }
    useDiscard(props, () => store.delete(templateId));
    return {
        getValues: () => {
            return Array.from(values(props, name));
        },
        addValue: (value) => {
            values(props, name).add(value);
        },
        removeValue: (value) => {
            values(props, name).delete(value);
        }
    }
}

export default useMultipleValueSelection;